module.exports = __webpack_public_path__ + "static/media/logo.c847c5b8.png";